<div class="site-background-main"></div>
<app-header-component ngSkipHydration="true" />
<main>
    <router-outlet />
</main>
<app-footer/>
